var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix"},[(_vm.i > _vm.x)?_c('span',{staticClass:"category-line"},[_vm._v("/")]):_vm._e(),_vm._v(" "),_c('span',{class:(_vm.lang=='ch'? 'category-name category-nameA':'category-name'),on:{"mousemove":_vm.mouseover,"mouseout":_vm.mouseout,"click":function($event){return _vm.onChange(_vm.id);}}},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }